export default __webpack_public_path__ + "static/media/partners-banner.07513b9e.jpg";